import { render, staticRenderFns } from "./LimitedTimeSelectRolePopup.vue?vue&type=template&id=70ac9cfc&scoped=true&"
import script from "./LimitedTimeSelectRolePopup.vue?vue&type=script&lang=js&"
export * from "./LimitedTimeSelectRolePopup.vue?vue&type=script&lang=js&"
import style0 from "./LimitedTimeSelectRolePopup.vue?vue&type=style&index=0&id=70ac9cfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac9cfc",
  null
  
)

export default component.exports